import React, { useEffect, useState } from 'react'
import useAxios from 'axios-hooks'
import { Modal, Input, Icon, Tabs } from 'antd'
import { getAuthHeader } from 'utils/auth'
import FormFooter from 'views/ScanSettings/components/ScanFilterBar/FormFooter'
import UserList from 'views/UserManagement/Users/components/UserList'
import { notificationToast } from 'components'

const { TextArea } = Input

function Users() {
  const [modalVisible, setModalVisible] = useState(false)
  const [invites, setInvites] = useState(false)

  const [{ data: listUsersResponse, loading: listUsersLoading, error: listUsersError }, listUsers] = useAxios(
    {
      url: 'account/users',
      method: 'GET',
      headers: getAuthHeader(),
      validateStatus: false
    },
    { manual: true }
  )

  const [
    { data: inviteUsersResponse, loading: inviteUsersLoading, error: inviteUsersError, response },
    inviteUsers
  ] = useAxios(
    {
      url: 'account/invite-users',
      method: 'POST',
      headers: getAuthHeader(),
      validateStatus: false
    },
    { manual: true }
  )

  useEffect(() => {
    listUsers()
    let interval = setInterval(() => {
      listUsers()
    }, 60000)
    return () => {
      if (interval) {
        clearInterval(interval)
      }
    }
  }, [])

  useEffect(() => {
    if (inviteUsersResponse && inviteUsersResponse.Errors && inviteUsersResponse.Errors.length) {
      openNotification('Cannot preview administration.', inviteUsersResponse.Errors)
    } else if (response && response.status == 200) {
      openNotification('Invites has been sent.')
      setInvites('')
      listUsers()
    }
  }, [inviteUsersResponse])

  const openNotification = (message, errors) => {
    if (!errors) {
      notificationToast({
        message: 'Success',
        description: message,
        icontype: 'check'
      })
    } else {
      notificationToast({
        message: 'Error',
        description: `${message} ${errors.join()}`,
        icontype: 'alert'
      })
    }
  }

  const handleOk = () => {
    setModalVisible(false)
    var data = invites.split(';').reduce(function(result, invite) {
      if (invite) {
        result.push({
          email: invite,
          is_account_admin: false
        });
      }
      return result;
    }, []);
    inviteUsers({ data: data })
    setInvites([])
  }

  const handleClose = () => {
    setInvites([])
    setModalVisible(false)
  }

  const handleSetInvites = e => {
    setInvites(e.target.value)
  }

  const handleInviteModalOpen = () => {
    setModalVisible(true)
  }

  return (
    <>
      <Modal
        title="INVITE USERS"
        centered
        width={600}
        visible={modalVisible}
        onCancel={() => handleClose()}
        footer={<FormFooter onOK={e => handleOk(e)} onClose={() => handleClose()} okText="Add" />}
      >
        <TextArea
          value={invites || ''}
          rows={6}
          onChange={handleSetInvites}
          placeholder="user@email.com;user2@email.com"
        />
      </Modal>

      <UserList
        data={listUsersResponse}
        loading={listUsersLoading}
        error={listUsersError}
        inviteUsers={inviteUsers}
        handleInviteModalOpen={handleInviteModalOpen}
      />
    </>
  )
}

export default Users
